import type { StyleRule } from '@archipro-design/aria';
import {
    getScrollbarStyle,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';

export const ManageCollaboratorsRootContainer: StyleRule = ({ theme }) => ({
    height: pxToRem(728),
    overflowY: 'hidden',
    background: theme.siteVariables.colors.white['000'],
});

export const CollaboratorListContainer: StyleRule = ({ theme }) => ({
    listStyle: 'none',
    height: `calc(${pxToRem(67)} * 10)`,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: pxToRem(728),
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingLeft: pxToRem(28),
    paddingRight: pxToRem(22),
    paddingTop: pxToRem(42),
    paddingBottom: pxToRem(60),
    ...getScrollbarStyle(theme),
});

export const CollaboratorListItem: StyleRule = () => ({
    display: 'flex',

    '&[data-ap:visibility="hidden"]': {
        visibility: 'hidden',
    },
});

export const CollaboratorName: StyleRule = ({ theme }) => ({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingLeft: pxToRem(9),
    [theme.screen.tablet]: {
        paddingLeft: pxToRem(14),
    },
});

export const CollaboratorRoot: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Roman55,
    fontSize: pxToRem(16),
    lineHeight: pxToRem(20),
    marginBottom: pxToRem(8),
    width: '100%',
});

export const ResendButton: StyleRule<{ isResent: boolean }> = ({
    theme,
    isResent,
}) => ({
    background: 'transparent',
    border: 'none',
    textDecoration: isResent ? 'none' : 'underline',
    cursor: isResent ? 'not-allowed' : 'pointer',

    [theme.screen.max.tablet]: {
        '&:not(:disabled)': {
            border: 'none',
            backgroundColor: theme.siteVariables.colors.charcoal['250'],
            padding: pxArrayToRem([7, 8]),
            textTransform: 'uppercase',
            textAlign: 'center',
            fontSize: pxToRem(14),
            color: theme.siteVariables.colors.white['100A'],
            borderRadius: pxToRem(2),
            textDecoration: 'none',
        },
    },
});

export const GridItemWrapper: StyleRule = () => ({
    alignItems: 'center',
});

export const ManageCollaboratorTitle: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(68),
    paddingLeft: pxToRem(28),
    margin: 0,
    ...theme.siteVariables.textStyles.Text.Medium65,
});

export const OwnerGridContainer: StyleRule = () => ({
    display: 'inline-grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
});

export const InvitedCollaboratorGrid: StyleRule = () => ({
    display: 'inline-grid',
    gridTemplateColumns: `${pxArrayToRem([230, 115])} 1fr`,
    gridTemplateRows: '1fr',
});

export const AvatarRoot: StyleRule = ({ theme }) => ({
    marginRight: pxToRem(5),
    [theme.screen.tablet]: {
        marginRight: pxToRem(10),
    },
});

export const CollaboratorGridContainer: StyleRule = () => ({
    display: 'inline-grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
});
